import { useSelector } from 'react-redux'
import { getSelectedCustomer } from '../../_augmentt/selectors/customers'
import { hasDiscoverLicense } from '../../_augmentt/utils/utils'

/**
 * Hook to return authorization flags
 */
const useAuthorization = () => {
  const selectedCustomer = useSelector(getSelectedCustomer)

  // org subscriptions
  const hasEngageAutopilotSubscription = useSelector(({ meta }) => meta.hasEngageAutopilotSubscription)
  const hasIntuneSubscription = useSelector(({ meta }) => meta.hasIntuneSubscription)
  const hasTeamsSubscription = useSelector(({ meta }) => meta.hasTeamsSubscription)
  const hasPurviewSubscription = useSelector(({ meta }) => meta.hasPurviewSubscription)
  const hasSharePointSubscription = useSelector(({ meta }) => meta.hasSharePointSubscription)
  const hasValidPostureBaselineSubscription = useSelector(({ meta }) => meta.hasValidPostureBaselineSubscription)

  // nfr licenses
  const hasNfrEngageEssentialsLicense = selectedCustomer?.hasNfrEngageEssentialsLicense
  // NFR Secure Premium is exposed under this legacy API field.
  const hasNfrSecurePremiumLicense = selectedCustomer?.hasNfrSecureEssentialsLicense

  // licenses
  const licenses = useSelector((state) => state.licenses.data)

  return {
    isAuthorizedForEngageAutopilot: hasEngageAutopilotSubscription || hasNfrEngageEssentialsLicense,
    isAuthorizedForIntune: hasIntuneSubscription || hasNfrSecurePremiumLicense,
    isAuthorizedForTeams: hasTeamsSubscription || hasNfrSecurePremiumLicense,
    isAuthorizedForSharePoint: hasSharePointSubscription || hasNfrSecurePremiumLicense,
    isAuthorizedForDiscover: hasDiscoverLicense(licenses),
    isAuthorizedForGroups: hasValidPostureBaselineSubscription,
    isAuthorizedForPurview: hasPurviewSubscription || hasNfrSecurePremiumLicense,
  }
}

export default useAuthorization
